var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.7309L21 15.7177H15V21.7309ZM18.75 0.642639H2.25C1.00734 0.642639 0 1.65219 0 2.89756V19.4337C0 20.7209 1.00734 21.7309 2.25 21.7309H13.5L13.5002 15.7177C13.5002 14.8876 14.1719 14.2145 15.0002 14.2145H21V2.93984C21 1.69447 19.9922 0.642639 18.75 0.642639Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.a965073d7563d454dbec4ae34bf0d42a.svg";
export { ForwardRef as ReactComponent };